/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */
import {
  // omit,
  union
} from 'lodash';
import {
  RECEIVED_SUBSCRIPTIONS,
  RECEIVED_UPDATE_SUBSCRIPTIONS,
  SAVE_SUBSCRIPTIONS_ERROR,
  SAVE_SUBSCRIPTIONS_SUCCESS,
  UPDATE_SUBSCRIPTIONS
} from 'state/subscriptions/SubscriptionsActions';
import { GPCSubscriptionsEnabled } from 'services/FeatureFlags';
import { getProductTypeFromElectionName } from 'services/Subscriptions';
/*
import {
  OPT_OUT_CATEGORY_ID,
  optOutCategories
} from 'services/Preferences';
*/

/*
const optOutElections = optOutCategories.map(category => {
  const updatedCategory = omit(category, 'key');
  updatedCategory['optOut'] = category.categoryId === OPT_OUT_CATEGORY_ID;
  return updatedCategory;
});
*/

const insertOptOutElection = (array, election) => {
  let newArray = array.slice();
  newArray.splice(1, 0, election);
  return newArray;
};

function updateOptOutElection(array, position, election) {
  return array.map((item, index) => {
    if (index !== position) {
      // This isn't the item we care about - keep it as-is
      return item;
    }

    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...election
    };
  });
}

const updateOptOut = (state, election) => {
  const position = state.optOutElections.findIndex(
    ({ categoryId }) => categoryId === election.categoryId
  );

  if (position !== -1) {
    return updateOptOutElection(state.optOutElections, position, election);
  }
  return insertOptOutElection(state.optOutElections, election);
};

/*
const mergeOptOutArrays = (elections, actionElections) => {
  return elections.map(e => {
    const foundItem = actionElections.find(({ categoryId }) => categoryId == e.categoryId);
    return foundItem ? foundItem : e;
  })
};
*/

export const initialState = {
  digitalSubscriptions: {
    priceSubscriptions: {
      typeId: -1,
      broadAssetClassIds: [],
      trpCodes: []
    },
    performanceSubscriptions: {
      typeId: -1,
      broadAssetClassIds: [],
      trpCodes: []
    },
    newsLetterIds: [],
    taxForms: false
  },
  complianceSubscriptions: [],
  optOutElections: []
};

export const subscriptionsReducer = (state = initialState, action) => {
  if (action.type === UPDATE_SUBSCRIPTIONS) {
    // this is not tied to rest but individual sections of subscriptions
    // rest simply submits if success state is already in good shape, but if it fails we will call GET and return old state
    // via received action
    const newState = {
      ...state,
      digitalSubscriptions: {
        ...state.digitalSubscriptions,
        ...(action.subscription.digitalSubscriptions
          ? action.subscription.digitalSubscriptions
          : {}),
        priceSubscriptions: {
          ...state.digitalSubscriptions.priceSubscriptions,
          ...(action.subscription.digitalSubscriptions &&
          action.subscription.digitalSubscriptions.priceSubscriptions
            ? action.subscription.digitalSubscriptions.priceSubscriptions
            : {})
        },
        performanceSubscriptions: {
          ...state.digitalSubscriptions.performanceSubscriptions,
          ...(action.subscription.digitalSubscriptions &&
          action.subscription.digitalSubscriptions.performanceSubscriptions
            ? action.subscription.digitalSubscriptions.performanceSubscriptions
            : {})
        }
      },
      complianceSubscriptions: action.subscription.complianceSubscriptions
        ? union(
            [...state.complianceSubscriptions],
            action.subscription.complianceSubscriptions
          )
        : [],
      optOutElections: action.subscription.optOutElections
        ? updateOptOut(state, action.subscription.optOutElections)
        : state.optOutElections
    };
    return newState;
  }

  if (action.type === RECEIVED_SUBSCRIPTIONS) {
    const { subscriptions } = action;
    /*
    const newState = {
      digitalSubscriptions: action.subscriptions.digitalSubscriptions,
      complianceSubscriptions: action.subscriptions.complianceSubscriptions,
      optOutElections: mergeOptOutArrays(state.optOutElections, action.subscriptions.optOutElections)
    };
    */

    //Adding product type to the opt out elections from the GET call to filter based on owned products
    if(GPCSubscriptionsEnabled()) {
      const { optOutElectionPreferences } = subscriptions;
      if(optOutElectionPreferences && optOutElectionPreferences.length) {
        const mappedElections = optOutElectionPreferences.map(election => {
          return {
            ...election,
            productType: getProductTypeFromElectionName(election)
          }
        });
        return {
          ...action.subscriptions,
          optOutElections: mappedElections
        }
      }
    }
    return action.subscriptions;
  }
  return state;
};

export const subscriptionsSaveReducer = (
  state = { saveStatus: {} },
  action
) => {
  if (action.type === RECEIVED_SUBSCRIPTIONS) {
    const { subscriptions } = action;
    /*
     * Subscription state is a deeply nested object with a variety of different shapes and uses.
     * It is easier to use `mergeWith`, than write a handler for each different situation;
     * mergeWith(cloneDeep(state), cloneDeep(action.subscriptions), mergeSubscriptionArrays)
     */

    //Adding product type to the opt out elections from the GET call to filter based on owned products
    if(GPCSubscriptionsEnabled()) {
      const { optOutElectionPreferences } = subscriptions;
      if(optOutElectionPreferences && optOutElectionPreferences.length) {
        const mappedElections = optOutElectionPreferences.map(election => {
          return {
            ...election,
            productType: getProductTypeFromElectionName(election)
          }
        });
        const updatedSubscriptions = {
          ...action.subscriptions,
          optOutElections: mappedElections
        };

        return {
          ...state,
          subscriptionsFromDB: updatedSubscriptions
        };
      }
    }
    return {
      ...state,
      subscriptionsFromDB: action.subscriptions
    };
  }

  //After successful update, take the current state of subscriptions and copy it to the subscriptionsFromDB
  //Do not need to do this for the subscriptions state as that is already updated to the most recent
  if(action.type === RECEIVED_UPDATE_SUBSCRIPTIONS) {
    const { updatedSubscriptions } = action;

    return {
      ...state,
      subscriptionsFromDB: updatedSubscriptions
    };

  }

  if (action.type === SAVE_SUBSCRIPTIONS_SUCCESS) {
    const lastUpdate = new Date().getDate();
    return {
      ...state,
      saveStatus: {
        lastUpdate,
        success: true,
        message: null
      }
    };
  }
  if (action.type === SAVE_SUBSCRIPTIONS_ERROR) {
    const lastUpdate = new Date().getDate();
    return {
      ...state,
      saveStatus: {
        lastUpdate,
        success: false,
        message:
          action.error && action.error.message ? action.error.message : ''
      }
    };
  }
  return state;
};
